<template>
    <div class="main">
        会议活动
    </div>
</template>

<script>
export default {

    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {}

}

</script>

<style lang="scss" scoped>
h1 {
    width: 100px;
}
</style>
